import axios from "axios";

export async function forgotPassword(body) {
  try {
    return await axios.patch(
      "https://rezin.pythonanywhere.com/auth/forgot/",
      body
    );
  } catch (error) {
    alert("Username or email was not found. Please try again.");
  }
}
